import includes from 'lodash/includes';
import { ErrorCode } from '@stigg-types/apiTypes';

export const isStiggError = (errorCode: string) => {
  return includes(Object.values(ErrorCode), errorCode);
};
